import { AUTH_URL } from 'src/constants/global'
import { useFetchCb } from '@gluedigital/ruse-fetch-extras'

export type ContactDetails = Record<string, unknown>

export default function useAuthContact(reason: string) {
  const doFetch = useFetchCb()

  const contact = async (details?: ContactDetails) => {
    return await doFetch(AUTH_URL + '/auth/contact', {
      method: 'POST',
      body: details ? { reason, details } : { reason }
    })
  }

  return { contact }
}
